import { InputNumber, Col, InputNumberProps } from 'antd';
import BaseProps from '../BaseProps/baseProps';
import { FormItemC } from '..';
import useDirection from 'src/shared/hooks/useDirection';
import useLocalization from 'src/shared/hooks/useLocalization';
import useDomain from 'src/shared/hooks/useDomain';
import { useHistory } from 'react-router-dom';
import useAuth from 'src/shared/hooks/useAuth';
import RoleEnum from 'src/shared/ts/enum/role.enum';

interface InputNumberComponentProps extends InputNumberProps, BaseProps {
  type?: 'price' | 'percent';
  currency?: string;
}

const InputNumberComponent = (props: InputNumberComponentProps) => {
  const { getCurrency } = useLocalization();
  const { symbol_native } = useDomain();
  const { hasRole } = useAuth();
  const { location } = useHistory() || {};
  const { pathname } = location || {};
  console.log('pathname', pathname);
  const {
    inForm = true,
    formItem,
    inCol = true,
    col,
    style,
    type,
    currency,
    ...antdProps
  } = props;

  let component = (
    <InputNumber style={{ width: '100%', ...style }} {...antdProps} />
  );
  switch (type) {
    case 'percent':
      component = (
        <InputNumber
          min={0}
          max={100}
          addonAfter='%'
          style={{ width: '100%', ...style }}
          {...antdProps}
        />
      );

      break;
    case 'price':
      component = (
        <InputNumber
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ width: '100%', ...style }}
          addonAfter={
            currency ||
            ((pathname?.includes('panel') &&
              (hasRole(RoleEnum.end_user) || hasRole(RoleEnum.tagrani_user))) ||
            !pathname?.includes('panel')
              ? getCurrency()?.currencySymbol
              : symbol_native)
          }
          {...antdProps}
        />
      );
      break;
  }
  if (inForm && !inCol) {
    return <FormItemC {...(formItem as any)}>{component}</FormItemC>;
  }

  if (inCol && !inForm) {
    return <Col {...col}>{component}</Col>;
  }
  if (inCol && inForm) {
    return (
      <Col {...col}>
        <FormItemC {...(formItem as any)}>{component}</FormItemC>
      </Col>
    );
  }
  return component;
};

export default InputNumberComponent;
